import { render, staticRenderFns } from "./ApplicantMessageSubject.vue?vue&type=template&id=96adcbd8"
import script from "./ApplicantMessageSubject.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports